/**
 * Кириллица → латиница по одной букве.
 *
 * Нужна ровно для ИМЕНИ ФАЙЛА скачанной карты: кириллица и пробелы не выживают
 * при пересылке и в чужих файловых системах.
 *
 * Живёт отдельным модулем осознанно: это единственное место кабинета, где
 * кириллица в коде — не подпись на экране, а таблица нормализации данных. В
 * общем файле она выглядела бы как забытый непереведённый текст (и проверка
 * `scripts/i18n/scan_cyrillic.py` считала бы её нарушением — здесь исключение
 * названо словами).
 *
 * Почему транслитерация, а не английское имя вида из справочника: у «Горбуши» и
 * «Горбуши 2» английское имя ОДНО (Pink Salmon), а это разные модели — файлы
 * затирали бы друг друга. Транслитерация повторяет ровно то, что человек выбрал
 * в сайдбаре, и потому различает их сама.
 */
const CYR_TO_LAT: Record<string, string> = {
  а: 'a', б: 'b', в: 'v', г: 'g', д: 'd', е: 'e', ё: 'e', ж: 'zh', з: 'z',
  и: 'i', й: 'y', к: 'k', л: 'l', м: 'm', н: 'n', о: 'o', п: 'p', р: 'r',
  с: 's', т: 't', у: 'u', ф: 'f', х: 'h', ц: 'ts', ч: 'ch', ш: 'sh',
  щ: 'sch', ъ: '', ы: 'y', ь: '', э: 'e', ю: 'yu', я: 'ya',
}

/** Строка → кусок имени файла: латиница, дефисы, ничего лишнего. */
export function slugify(label: string | null | undefined): string {
  if (!label) return ''
  const lat = label
    .toLowerCase()
    .split('')
    .map(ch => (ch in CYR_TO_LAT ? CYR_TO_LAT[ch] : ch))
    .join('')
  return lat.replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '')
}
